export const connecticut = {
  "09000": "Connecticut",
  "09001": "Fairfield County",
  "09003": "Hartford County",
  "09005": "Litchfield County",
  "09007": "Middlesex County",
  "09009": "New Haven County",
  "09011": "New London County",
  "09013": "Tolland County",
  "09015": "Windham County",
};
